"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PDFAnalyticsEvents = exports.OverlayEvents = exports.InternalEvents = exports.FilePreviewEvents = exports.DOCUMENT_VIEW_UPDATE_EVENTS_LIST = exports.CoreEvents = exports.AnnotationTypes = exports.AnnotationEvents = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

// Events which are meant to SDK
const InternalEvents = exports.InternalEvents = {
  PREVIEW_REF_READY: "PREVIEW_REF_READY",
  RELOAD_APP: "RELOAD_APP",
  FILE_NAME_TOAST_VISIBILITY: "FILE_NAME_TOAST_VISIBILITY",
  DOCUMENT_VIEW_UPDATE: "DOCUMENT_VIEW_UPDATE",
  FILE_PREVIEW_READY: "FILE_PREVIEW_READY",
  FILE_PREVIEW_FAILED: "FILE_PREVIEW_FAILED",
  APP_PERF_DATA: "APP_PERF_DATA",
  FILE_LOADING_PROGRESS: "FILE_LOADING_PROGRESS",
  FILE_FIRST_PAGE_LOADING_DONE: "FILE_FIRST_PAGE_LOADING_DONE",
  ACTION_CONFIG_UPDATE: "ACTION_CONFIG_UPDATE",
  POLLING_CONFIG_UPDATE: "POLLING_CONFIG_UPDATE",
  GO_TO_LOCATION: "GO_TO_LOCATION",
  CLOSE_WINDOW: "CLOSE_WINDOW",
  DOCUMENT_VIEW_STATE_UPDATE: "DOCUMENT_VIEW_STATE_UPDATE",
  DOCUMENT_VIEW_UPDATE_EVENT: "DOCUMENT_VIEW_UPDATE_EVENT",
  SUBSCRIBE_TO_RHP: "SUBSCRIBE_TO_RHP"
};
const AnnotationEvents = exports.AnnotationEvents = {
  ANNOTATION_ADDED: "ANNOTATION_ADDED",
  ANNOTATION_UPDATED: "ANNOTATION_UPDATED",
  ANNOTATION_DELETED: "ANNOTATION_DELETED",
  ANNOTATION_SELECTED: "ANNOTATION_SELECTED",
  ANNOTATION_UNSELECTED: "ANNOTATION_UNSELECTED",
  ANNOTATION_MODE_STARTED: "ANNOTATION_MODE_STARTED",
  ANNOTATION_MODE_ENDED: "ANNOTATION_MODE_ENDED",
  ANNOTATION_CLICKED: "ANNOTATION_CLICKED",
  ANNOTATION_MOUSE_OVER: "ANNOTATION_MOUSE_OVER",
  ANNOTATION_MOUSE_OUT: "ANNOTATION_MOUSE_OUT",
  ANNOTATION_COUNT: "ANNOTATION_COUNT"
};
const AnnotationTypes = exports.AnnotationTypes = {
  HIGHLIGHT: "highlight",
  STRIKEOUT: "strikeout",
  UNDERLINE: "underline",
  SHAPE: "shape",
  NOTE: "note",
  FREETEXT: "freetext"
};
const PDFAnalyticsEvents = exports.PDFAnalyticsEvents = {
  DOCUMENT_OPEN: "DOCUMENT_OPEN",
  PAGE_VIEW: "PAGE_VIEW",
  DOCUMENT_DOWNLOAD: "DOCUMENT_DOWNLOAD",
  DOCUMENT_PRINT: "DOCUMENT_PRINT",
  TEXT_SEARCH: "TEXT_SEARCH",
  BOOKMARK_ITEM_CLICK: "BOOKMARK_ITEM_CLICK",
  HYPERLINK_OPEN: "HYPERLINK_OPEN",
  TEXT_COPY: "TEXT_COPY",
  ZOOM_LEVEL: "ZOOM_LEVEL"
};
const FilePreviewEvents = exports.FilePreviewEvents = {
  PREVIEW_KEY_DOWN: "PREVIEW_KEY_DOWN",
  PREVIEW_PAGE_VIEW_SCROLLED: "PREVIEW_PAGE_VIEW_SCROLLED",
  PREVIEW_DOCUMENT_CLICK: "PREVIEW_DOCUMENT_CLICK",
  PREVIEW_PAGE_CLICK: "PREVIEW_PAGE_CLICK",
  PREVIEW_PAGE_DOUBLE_CLICK: "PREVIEW_PAGE_DOUBLE_CLICK",
  PREVIEW_PAGE_HOVER: "PREVIEW_PAGE_HOVER",
  PREVIEW_PAGE_MOUSE_ENTER: "PREVIEW_PAGE_MOUSE_ENTER",
  PREVIEW_PAGE_MOUSE_LEAVE: "PREVIEW_PAGE_MOUSE_LEAVE",
  CURRENT_ACTIVE_PAGE: "CURRENT_ACTIVE_PAGE",
  PREVIEW_SELECTION_END: "PREVIEW_SELECTION_END",
  VIEW_MODE_CHANGE: "VIEW_MODE_CHANGE",
  PREVIEW_ZOOM: "PREVIEW_ZOOM",
  PAGES_IN_VIEW_CHANGE: "PAGES_IN_VIEW_CHANGE",
  UNSUPPORTED_FEATURE_FOUND: "UNSUPPORTED_FEATURE_FOUND",
  PREVIEW_ERROR_EVENTS: "PREVIEW_ERROR_EVENTS",
  EDIT_PRE_PROCESSING_INITIATED: "EDIT_PRE_PROCESSING_INITIATED",
  EDIT_ENTER_SUCCESSFUL: "EDIT_ENTER_SUCCESSFUL",
  HANDLE_ENTER_EDIT: "HANDLE_ENTER_EDIT",
  SUBMIT_FORM: "SUBMIT_FORM",
  HANDLE_EDIT_UPSELL: "HANDLE_EDIT_UPSELL",
  OPEN_DOCUMENT_IN_DESKTOP: "OPEN_DOCUMENT_IN_DESKTOP",
  HANDLE_OPEN_NATIVE_APP: "HANDLE_OPEN_NATIVE_APP",
  CONTEXT_MENU_ITEM_CLICKED: "CONTEXT_MENU_ITEM_CLICKED",
  GENAI_OPERATION_PERFORMED: "GENAI_OPERATION_PERFORMED",
  DIGITAL_SIGNATURE_VALIDATION_STATUS_UPDATED: "DIGITAL_SIGNATURE_VALIDATION_STATUS_UPDATED",
  EDIT_TOOLS_USED: "EDIT_TOOLS_USED",
  FALLBACK_PRINT: "FALLBACK_PRINT",
  WAITING_ON_COMPLETE_PDF_BUFFER: "WAITING_ON_COMPLETE_PDF_BUFFER",
  HANDLE_EDIT_KEYBOARD_SHORTCUT: "HANDLE_EDIT_KEYBOARD_SHORTCUT",
  DOCUMENT_VIEW_THEME_CHANGE: "DOCUMENT_VIEW_THEME_CHANGE",
  HANDLE_EDIT_LOCAL_FONT_PRIMING_DIALOG_EVENTS: "HANDLE_EDIT_LOCAL_FONT_PRIMING_DIALOG_EVENTS",
  TOUCH_START: "TOUCH_START",
  TOUCH_END: "TOUCH_END",
  FULL_SCREEN_VIEW_ENTRY: "FULL_SCREEN_VIEW_ENTRY",
  FULL_SCREEN_VIEW_EXIT: "FULL_SCREEN_VIEW_EXIT"
};
const OverlayEvents = exports.OverlayEvents = {
  PAGE_OVERLAY_ATTACHED: "PAGE_OVERLAY_ATTACHED",
  PAGE_OVERLAY_REMOVED: "PAGE_OVERLAY_REMOVED"
};
const CoreEvents = exports.CoreEvents = {
  CUSTOMIZE_TOP_BAR: "CUSTOMIZE_TOP_BAR"
};
const DOCUMENT_VIEW_UPDATE_EVENTS_LIST = exports.DOCUMENT_VIEW_UPDATE_EVENTS_LIST = {
  preview: [InternalEvents.DOCUMENT_VIEW_STATE_UPDATE, InternalEvents.DOCUMENT_VIEW_UPDATE, FilePreviewEvents.PREVIEW_SELECTION_END, FilePreviewEvents.PREVIEW_PAGE_VIEW_SCROLLED, FilePreviewEvents.PREVIEW_ZOOM, FilePreviewEvents.PAGES_IN_VIEW_CHANGE],
  comments: [AnnotationEvents.ANNOTATION_SELECTED, AnnotationEvents.ANNOTATION_CLICKED, AnnotationEvents.ANNOTATION_COUNT, AnnotationEvents.ANNOTATION_MODE_STARTED, AnnotationEvents.ANNOTATION_MODE_ENDED, AnnotationEvents.ANNOTATION_UNSELECTED],
  rhp: [InternalEvents.SUBSCRIBE_TO_RHP]
};
const Events = {
  VIEWER_UNMOUNT: "VIEWER_UNMOUNT",
  PDF_VIEWER_OPEN: "PDF_VIEWER_OPEN",
  PDF_VIEWER_CLOSE: "PDF_VIEWER_CLOSE",
  APP_RENDERING_START: "APP_RENDERING_START",
  APP_RENDERING_DONE: "APP_RENDERING_DONE",
  APP_RENDERING_FAILED: "APP_RENDERING_FAILED",
  ACTION_ICONS: "ACTION_ICONS",
  SEARCH_UI_TOGGLE: "SEARCH_UI_TOGGLE",
  FILE_STATUS: "FILE_STATUS",
  FULL_SCREEN_TOGGLE: "FULL_SCREEN_TOGGLE",
  FILE_DOWNLOAD_FAILED: "FILE_DOWNLOAD_FAILED",
  PDF_VIEWER_READY: "PDF_VIEWER_READY",
  FIRST_AJS_PAGE_RENDERED: "FIRST_AJS_PAGE_RENDERED",
  FILE_LINEARIZATION_STATUS: "FILE_LINEARIZATION_STATUS"
};
var _default = exports.default = Events;